/**
 * Copyright 2020 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const movePlanToPipeline = `mutation MovePlanToPipeline($input: MovePlanToPipelineInput!) {
    movePlanToPipeline(input: $input) {id}
  }
  `;
